<template>
  <s-button
    v-bind="$attrs"
    @click="handleClick"
    :loading="loading"
    class="ssc-button-icon-center"
  >
    <slot>{{ $i18n('Export') }}</slot>
  </s-button>
</template>

<script lang="ts">
import { Component, Prop, Vue } from 'vue-property-decorator';
import { ExportButtonCore, ExportButtonProps } from './core';

@Component({
  name: 'WmsExportButton',
})
export default class WmsExportButton extends Vue {
  @Prop({ required: true })
  exportModule!: ExportButtonProps['exportModule'];
  @Prop({ required: true })
  exportTaskType!: ExportButtonProps['exportTaskType'];
  @Prop({
    default: () => ({}),
  })
  exportExtraData: ExportButtonProps['exportExtraData'];
  @Prop()
  getExportExtraData: ExportButtonProps['getExportExtraData'];
  @Prop()
  beforeExport?: ExportButtonProps['beforeExport'];

  exportCore!: ExportButtonCore;
  unsubscribe: () => void;
  loading = false;

  created() {
    this.exportCore = new ExportButtonCore({
      exportModule: this.exportModule,
      exportTaskType: this.exportTaskType,
      getExportExtraData: this.getExportExtraData,
    });
    this.unsubscribe = this.exportCore.subscribe((loading) => {
      this.loading = loading;
    });
  }

  beforeDestroy() {
    this.unsubscribe?.();
  }

  handleClick() {
    this.exportCore.handleExport(this.exportExtraData, this.beforeExport);
  }
}
</script>
